import Axios from 'axios'

// Config
import Config from '../config'

const { AWS_IMAGE_UPLOAD } = Config

// Verificar todas las variables de entorno AWS requeridas de manera más eficiente
const requiredAwsVars = {
    AWS_IMAGE_UPLOAD,
}

Object.entries(requiredAwsVars).forEach(([varName, value]) => {
    if (!value) {
        // eslint-disable-next-line no-console
        console.error(`${varName} debe ser declarado en las variables de entorno del sistema`)
    }
})

const baseURL = `${AWS_IMAGE_UPLOAD}`
const ApiAWS = Axios.create({
    baseURL,
})

export class AWS {
    static uploadImage = ({ formData, userId, token }: PostUpload): Promise<string | void> =>
        ApiAWS.post<UploadImage>(`/upload/${userId}`, formData, {
            headers: { Authorization: token },
        }).then(({ data }) => data.thumbnailUrl.split('?')[0])
}

export type PostUpload = {
    formData: FormData
    userId: string
    token: string
}

interface UploadImage {
    id: string
    mimeType: string
    originalKey: string
    thumbnailKey: string
    bucket: string
    fileName: string
    originalUrl: string
    thumbnailUrl: string
    originalSize: number
    stage: string
    secretKey: string
}
